import type { GetInvoicesOverviewsNewResponse } from '@vy/api-definition';
import { GetInvoicesOverviewsNewResponseSchema } from '@vy/api-definition';
import type { WeftApi } from '@vy/client';
import type { QueryClient, UseQueryOptions } from 'react-query';
import { useQuery, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../../services/api';
import { queryKeys } from '../../../services/query-key/query-keys';

type UseInvoicesOverviewsNewPayload = Parameters<WeftApi['getInvoicesOverviewsNew']>[0];

export async function invoicesOverviewsNewQuery(
  payload: UseInvoicesOverviewsNewPayload,
  signal?: AbortSignal,
) {
  const api = getPrivateApi();
  const response = await api.getInvoicesOverviewsNew(payload, { signal });
  return GetInvoicesOverviewsNewResponseSchema.parse(response);
}

export function useInvoicesOverviewsNew(
  payload: UseInvoicesOverviewsNewPayload = {},
  options?: UseQueryOptions<GetInvoicesOverviewsNewResponse>,
) {
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: queryKeys.invoicesOverviewsNew(...Object.values(payload)),
    queryFn: async ({ signal }) => {
      await cancelGetInvoicesOverviewsNewQueries(queryClient);

      return invoicesOverviewsNewQuery(payload, signal);
    },
    ...options,
  });
}

export async function prefetchInvoicesOverviewsNew(
  queryClient: QueryClient,
  payload: UseInvoicesOverviewsNewPayload = {},
) {
  return queryClient.prefetchQuery(queryKeys.invoicesOverviewsNew(...Object.values(payload)), () =>
    invoicesOverviewsNewQuery(payload),
  );
}

async function cancelGetInvoicesOverviewsNewQueries(queryClient: QueryClient) {
  await queryClient.cancelQueries({
    predicate: (query) => query.queryKey[0] === queryKeys.invoicesOverviewsNew()[0],
  });
}
